import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex } from "../../models";
import { successfulLogin } from "../../auth/authDataSlice";
import { InvoiceFilter } from "./types";

type InvoicePageState = {
  index: PageIndex;
  filter: InvoiceFilter;
};

export const initialState: InvoicePageState = {
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
  filter: {},
};

const name = "invoices";

const invoicesSlice = createSlice({
  name,
  initialState,
  reducers: {
    setInvoiceIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    resetInvoiceIdices: (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }),
    setFilter: (state, action: PayloadAction<InvoiceFilter>) => ({
      ...state,
      filter: action.payload,
    }),
    removeFilter: (state, action: PayloadAction<keyof InvoiceFilter>) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(successfulLogin, (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }));
  },
});

export const {
  setInvoiceIndex,
  resetInvoiceIdices,
  setFilter,
  removeFilter,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;
